import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';

import { reloadSpace } from '~src/spacesPlatform/sagas/content/RefreshContentSagas';

import {
  SiteUserEditGroupMembership, SiteUserEditSiteRole,
  SiteUserForcePasswordUpdate, SiteUserRemove, SiteUserResetLoginRateLimiting,
  SiteUserSetAuthentication
} from '../../app/actions/AppActionTypes';
import { requestFailed } from '../../app/actions/RequestFailedAction';
import { forcePasswordUpdateOnSiteUsers } from '../../authentication/actions/ForcePasswordUpdateAction';
import { resetLoginRateLimitingOnSiteUsers } from '../../authentication/actions/ResetLoginRateLimitingAction';
import { Messages } from '../../codegen/Localize';
import { UpdateUserAuthenticationAction } from '../../settings/siteAuthSettings/services/UpdateUserAuthenticationAction';
import { Set } from '../../ts/models/Set';
import { showEditGroupMembershipDialog } from '../groups/services/actions/EditGroupMembershipDialogAction';
import { RemoveUsersAction } from '../services/RemoveUsersAction';
import { SetSiteUsersSiteRoleAction } from '../services/SetSiteUsersSiteRoleAction';
import { SiteUserMenuAction } from '../users/actions/SiteUserMenuActions';
import { ISiteUserInfo } from '../users/models/ISiteUserInfo';

export function removeUsers(users: ISiteUserInfo[]) {
  return RemoveUsersAction.showRemoveUsersFromSiteDialog(Set.fromIdItemArray(users));
}

export function* handleRemoveUsers(action: SiteUserMenuAction): SagaIterator {
  try {
    yield call(removeUsers, action.items);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    // This is to prevent error notifcation from showing up when the dialog is dismissed
    // To be fixed after TFSID 1121927
    return;
  }
}

export function editSiteRole(users: ISiteUserInfo[]) {
  return SetSiteUsersSiteRoleAction.showSetSiteUsersSiteRoleDialog(Set.fromIdItemArray(users));
}

export function* handleEditSiteRole(action: SiteUserMenuAction): SagaIterator {
  try {
    yield call(editSiteRole, action.items);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function editGroupMembership(users: ISiteUserInfo[]) {
  return showEditGroupMembershipDialog(Set.fromIdItemArray(users));
}

export function* handleEditGroupMembership(action: SiteUserMenuAction): SagaIterator {
  try {
    yield call(editGroupMembership, action.items);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function setAuthentication(users: ISiteUserInfo[]) {
  return UpdateUserAuthenticationAction.showUpdateUserAuthenticationDialog(Set.fromIdItemArray(users));
}

export function* handleSetAuthentication(action: SiteUserMenuAction): SagaIterator {
  try {
    yield call(setAuthentication, action.items);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function forcePasswordUpdate(users: ISiteUserInfo[]) {
  return forcePasswordUpdateOnSiteUsers(Set.fromIdItemArray(users));
}

export function* handleForcePasswordUpdate(action: SiteUserMenuAction): SagaIterator {
  try {
    yield call(forcePasswordUpdate, action.items);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function resetLoginRateLimiting(users: ISiteUserInfo[]) {
  return resetLoginRateLimitingOnSiteUsers(Set.fromIdItemArray(users));
}

export function* handleResetLoginRateLimiting(action: SiteUserMenuAction): SagaIterator {
  try {
    yield call(resetLoginRateLimiting, action.items);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function* rootSiteUserMenuActionSaga(): SagaIterator {
  yield takeEvery(SiteUserEditGroupMembership, handleEditGroupMembership);
  yield takeEvery(SiteUserEditSiteRole, handleEditSiteRole);
  yield takeEvery(SiteUserRemove, handleRemoveUsers);
  yield takeEvery(SiteUserSetAuthentication, handleSetAuthentication);
  yield takeEvery(SiteUserForcePasswordUpdate, handleForcePasswordUpdate);
  yield takeEvery(SiteUserResetLoginRateLimiting, handleResetLoginRateLimiting);
}
